export const AdminPanelApiUrl = {
    AllAgents: '/agent/all',
    EditAgent: '/agent',
    SupportedCountries: '/country/mine/all',
    GeneralKnowledgeFiles: '/document/mine/all',
    UpdateGeneralKnowledgeFiles: '/document/upload/mine',
    DeleteGeneralKnowledgeFile: '/document/mine',
    FileUploadConstraints: '/document/upload/constraints',
    AvatarSupportedLanguages: '/avatar/supported/languages',
    UpdatePredefinedPromptsByRole: '/prompt/role/replace',
    deletePredefinedPromptByRole: (roleId: string, promptId: string) =>
        `/prompt/role/${roleId}/prompt/${promptId}`,
    UpdateGeneralPredefinedPrompts: '/prompt/group/replace',
    deleteGeneralPredefinedPrompt: (groupId: string, promptId: string) =>
        `/prompt/group/${groupId}/prompt/${promptId}`,
    deleteGeneralPredefinedPromptGroup: (groupId: string) => `/prompt/group/${groupId}`,
} as const;
